import posthog from "posthog-js";
import { usePostHog } from "@posthog/react";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { environment } from "@web-src/environments/environment";
import { selectUserId } from "@web-src/features/auth/authSlice";
import useEntity from "@web-src/features/app/hooks/useEntity";

export const isPostHogEnabled = () =>
  !!environment.posthogWhitelistHosts.find((item) =>
    // eslint-disable-next-line no-restricted-globals
    item instanceof RegExp ? item.test(location.host) : item === location.host
  );

export const posthogOptions = {
  api_host: environment.posthogHost || "https://us.i.posthog.com",
  ui_host: environment.posthogHost ? "https://ui.posthog.com" : undefined,
  disable_session_recording: true,
  capture_pageview: true,
  capture_pageleave: true,
  opt_out_capturing_by_default: !isPostHogEnabled(),
};

export const useStartSessionRecording = () => {
  const posthogClient = usePostHog();

  useEffect(() => {
    if (!isPostHogEnabled() || !posthogClient) return;
    posthogClient.startSessionRecording();
  }, [posthogClient]);
};

export const useStopSessionRecording = () => {
  const posthogClient = usePostHog();

  useEffect(() => {
    if (!isPostHogEnabled() || !posthogClient) return;
    posthogClient.stopSessionRecording();
  }, [posthogClient]);
};

export const PostHogUserSetter: React.FC = () => {
  const meId = useSelector(selectUserId);
  const { entity } = useEntity();

  useEffect(() => {
    if (!isPostHogEnabled() || !meId) return;
    posthog.identify(meId, { entityId: entity?.id });
    posthog.stopSessionRecording();
  }, [entity?.id, meId]);

  return null;
};
